module.exports = __webpack_public_path__ + "img/signature.62b36967.png";